// extracted by mini-css-extract-plugin
export default {"scopeSelect":"QuerySelection__scopeSelect__Hd57-"};